<template>
  <basic-container>
    <avue-crud
      :option="optionParent"
      :table-loading="loading"
      :data="dataParent"
      :page="pageParent"
      ref="crud"
      v-model="formParent"
      :permission="permissionObj"
      :before-open="beforeOpen"
      @row-del="rowDel"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-click="handleRowClick"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoadParent"
    >
      <template #menu-left>
        <el-button
          type="danger"
          icon="el-icon-delete"
          v-if="permission.dictbiz_delete"
          plain
          @click="handleDelete"
          >{{ Lang.btn.delete }}
        </el-button>
      </template>
      <template #menu="scope">
        <el-button
          type="primary"
          icon="el-icon-setting"
          @click.stop="handleRowClick(scope.row)"
          v-if="userInfo.role_name.includes('admin')"
          > {{$t('mBtn.dictConfig')}}
        </el-button>
      </template>
      <template #code="{ row }">
        <el-tag @click="handleRowClick(row)" style="cursor: pointer">{{ row.code }}</el-tag>
      </template>
      <template #isSealed="{ row }">
        <el-tag>{{ row.isSealed === 0 ? Lang.label.no : Lang.label.yes }}</el-tag>
      </template>
    </avue-crud>
    <el-dialog :title="`[${dictValue}]${$t('mBtn.dictConfig')}`"
      append-to-body
      v-model="box"
      style="padding: 10px;"
      width="1000px">
      <avue-crud
        :option="optionChild"
        :table-loading="loadingChild"
        :data="dataChild"
        ref="crudChild"
        v-model="formChild"
        :permission="permissionObj"
        :before-open="beforeOpenChild"
        :before-close="beforeCloseChild"
        @row-del="rowDelChild"
        @row-update="rowUpdateChild"
        @row-save="rowSaveChild"
        @search-change="searchChangeChild"
        @search-reset="searchResetChild"
        @selection-change="selectionChangeChild"
        @current-change="currentChangeChild"
        @size-change="sizeChangeChild"
        @refresh-change="refreshChangeChild"
        @on-load="onLoadChild"
      >
        <template #menu-left>
          <el-button
            type="danger"
            icon="el-icon-delete"
            v-if="permission.dict_delete"
            plain
            @click="handleDelete"
            >{{ Lang.btn.delete }}
          </el-button>
        </template>
        <template #menu="scope">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click.stop="handleAdd(scope.row, scope.index)"
            v-if="userInfo.role_name.includes('admin')"
            >{{ Lang.btn.addSub }}
          </el-button>
        </template>
        <template #isSealed="{ row }">
          <el-tag>{{ row.isSealed === 0 ? Lang.label.no : Lang.label.yes }}</el-tag>
        </template>
      </avue-crud>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  getParentList,
  getChildList,
  remove,
  update,
  add,
  getDict,
  getDictTree,
} from '@/api/system/dictbiz';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      dictValue: '暂无',
      parentId: -1,
      formParent: {},
      formChild: {},
      selectionList: [],
      query: {},
      box: false,
      loading: true,
      loadingChild: true,
      pageParent: {
        pageSize: 10,
        pageSizes: [10, 30, 50, 100, 200],
        currentPage: 1,
        total: 0,
      },
      pageChild: {
        pageSize: 10,
        pageSizes: [10, 30, 50, 100, 200],
        currentPage: 1,
        total: 0,
      },
      dataParent: [],
      dataChild: [],
      optionParent: {
        height: 'auto',
        calcHeight: 104,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        searchMenuPosition: 'right',
        searchGutter: 20,
        gutter: 12,
        border: true,
        index: true,
        indexLabel: this.Lang.table.serialNumber,
        indexWidth: '100%',
        selection: true,
        viewBtn: true,
        menuType: 'button',
        menuTitle: this.Lang.label.operation,
        menuHeaderAlign: 'right', // 操作按钮样式
        menuWidth: 350,
        dialogWidth: 880,
        dialogClickModal: false,
        column: [
          {
            label: this.$t('theader.dictionaryNumber'),
            prop: 'code',
            search: true,
            slot: true,
            span: 24,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputDictNum,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.$t('theader.dictionaryName'),
            prop: 'dictValue',
            search: true,
            align: 'center',
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputDictName,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.enName,
            prop: 'enDictValue',
            search: true,
            align: 'center',
            rules: [
              {
                required: true,
                message: this.Lang.tips.inputDictEnName,
                trigger: 'blur',
              },
            ],
          },
          // {
          //   label: this.Lang.label.localName,
          //   prop: 'localDictValue',
          //   search: true,
          //   align: 'center',
          //   rules: [
          //     {
          //       required: true,
          //       message: this.Lang.tips.inputDictLocalName,
          //       trigger: 'blur',
          //     },
          //   ],
          // },
          {
            label: this.$t('theader.dictionarySorting'),
            prop: 'sort',
            maxlength: 5,
            type: 'number',
            align: 'right',
            width: 100,
            rules: [
              {
                required: true,
                message: this.Lang.tips.inputDictSort,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.$t('theader.archive'),
            prop: 'isSealed',
            type: 'switch',
            align: 'center',
            width: 100,
            dicData: [
              {
                label: this.Lang.label.no,
                value: 0,
              },
              {
                label: this.Lang.label.yes,
                value: 1,
              },
            ],
            value: 0,
            slot: true,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzSelectIfSealedUp,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.dictRemark,
            prop: 'remark',
            hide: true,
          },
        ],
      },
      optionChild: {
        height: 'auto',
        calcHeight: 395,
        tip: false,
        searchShow: true,
        searchMenuSpan: 10,
        tree: true,
        border: true,
        index: true,
        indexLabel: this.Lang.table.serialNumber,
        indexWidth: '100%',
        selection: true,
        viewBtn: true,
        menuType: 'button',
        menuTitle: this.Lang.label.operation,
        menuHeaderAlign: 'right', // 操作按钮样式
        menuWidth: 480,
        dialogWidth: 880,
        dialogClickModal: false,
        column: [
          {
            label: this.$t('theader.dictionaryNumber'),
            prop: 'code',
            addDisabled: true,
            editDisabled: true,
            search: true,
            span: 24,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputDictNum,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.$t('theader.dictionaryName'),
            prop: 'dictValue',
            search: true,
            align: 'center',
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputDictName,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.enName,
            prop: 'enDictValue',
            search: true,
            align: 'center',
            rules: [
              {
                required: true,
                message: this.Lang.tips.inputDictEnName,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.localName,
            prop: 'localDictValue',
            search: true,
            align: 'center',
            rules: [
              {
                required: true,
                message: this.Lang.tips.inputDictLocalName,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.superiorDict,
            prop: 'parentId',
            type: 'tree',
            dicData: [],
            hide: true,
            props: {
              label: 'title',
            },
            addDisabled: true,
            editDisabled: true,
            rules: [
              {
                required: false,
                message: this.Lang.tips.plzSelectSupperiorDict,
                trigger: 'click',
              },
            ],
          },
          {
            label: this.Lang.label.dictKey,
            prop: 'dictKey',
            width: 85,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputDictKey,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.dictSort,
            prop: 'sort',
            maxlength: 5,
            type: 'number',
            align: 'right',
            hide: true,
            rules: [
              {
                required: true,
                message: this.Lang.tips.inputDictSort,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.$t('theader.archive'),
            prop: 'isSealed',
            type: 'switch',
            align: 'center',
            width: 80,
            dicData: [
              {
                label: this.Lang.label.no,
                value: 0,
              },
              {
                label: this.Lang.label.yes,
                value: 1,
              },
            ],
            value: 0,
            slot: true,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzSelectIfSealedUp,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.dictRemark,
            prop: 'remark',
            hide: true,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['menuItem', 'permission']),
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
          obj[btnType+'Btn'] = true; // 兼容
          if (btnType === 'delete') {
            obj.delBtn = true;
          }
        }
      }))
      return obj
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      getDictTree().then(res => {
        const column = this.findObject(this.optionChild.column, 'parentId');
        column.dicData = res.data.data;
      });
    },
    handleAdd(row) {
      this.formChild.dictValue = '';
      this.formChild.dictKey = '';
      this.formChild.sort = 0;
      this.formChild.isSealed = 0;
      this.formChild.remark = '';
      this.formChild.parentId = row.id;
      this.$refs.crudChild.rowAdd();
    },
    rowSave(row, done, loading) {
      const form = {
        ...row,
        dictKey: -1,
      };
      add(form).then(
        () => {
          this.onLoadParent(this.pageParent);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoadParent(this.pageParent);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.onLoadChild(this.pageChild);
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoadParent(this.pageParent);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    handleRowClick(row) {
      this.query = {};
      this.parentId = row.id;
      this.dictValue = row.dictValue;

      const code = this.findObject(this.optionChild.column, 'code');
      code.value = row.code;
      const parentId = this.findObject(this.optionChild.column, 'parentId');
      parentId.value = row.id;

      this.formChild.code = row.code;
      this.formChild.parentId = row.id;

      this.box = true;
      this.onLoadChild(this.pageChild);
    },
    searchReset() {
      this.query = {};
      this.onLoadParent(this.pageParent);
    },
    searchChange(params, done) {
      this.query = params;
      this.pageParent.currentPage = 1;
      this.onLoadParent(this.pageParent, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoadParent(this.pageParent);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDict(this.formParent.id).then(res => {
          this.formParent = res.data.data;
        });
      }
      done();
    },
    currentChange(currentPage) {
      this.pageParent.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.pageParent.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoadParent(this.pageParent, this.query);
    },
    rowSaveChild(row, done, loading) {
      add(row).then(
        () => {
          this.onLoadChild(this.pageChild);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdateChild(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoadChild(this.pageChild);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDelChild(row) {
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoadChild(this.pageChild);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    searchResetChild() {
      this.query = {};
      this.onLoadChild(this.pageChild);
    },
    searchChangeChild(params, done) {
      this.query = params;
      this.pageChild.currentPage = 1;
      this.onLoadChild(this.pageChild, params);
      done();
    },
    selectionChangeChild(list) {
      this.selectionList = list;
    },
    selectionClearChild() {
      this.selectionList = [];
      this.$refs.crudChild.toggleSelection();
    },
    handleDeleteChild() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoadChild(this.pageChild);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.crudChild.toggleSelection();
        });
    },
    beforeOpenChild(done, type) {
      if (['add', 'edit'].includes(type)) {
        this.initData();
      }
      if (['edit', 'view'].includes(type)) {
        getDict(this.formChild.id).then(res => {
          this.formChild = res.data.data;
        });
      }
      done();
    },
    beforeCloseChild(done) {
      this.$refs.crudChild.modelValue.parentId = this.parentId;
      this.$refs.crudChild.option.column.filter(item => {
        if (item.prop === 'parentId') {
          item.value = this.parentId;
        }
      });
      done();
    },
    currentChangeChild(currentPage) {
      this.pageChild.currentPage = currentPage;
    },
    sizeChangeChild(pageSize) {
      this.pageChild.pageSize = pageSize;
    },
    refreshChangeChild() {
      this.onLoadChild(this.pageChild, this.query);
    },
    onLoadParent(page, params = {}) {
      this.loading = true;
      getParentList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(
        res => {
          const data = res.data.data;
          this.pageParent.total = data.total;
          this.dataParent = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
    onLoadChild(page, params = {}) {
      this.loadingChild = true;
      getChildList(
        page.currentPage,
        page.pageSize,
        this.parentId,
        Object.assign(params, this.query)
      ).then(res => {
        this.dataChild = res.data.data;
        this.loadingChild = false;
        this.selectionClear();
      });
    },
  },
};
</script>
